
// Angular
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
// 3rdparty
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
// Hostware
import { Alert, HwAlertService, ToastPosition } from '@globalshared/hw-alert-component/src/lib';
import { HwConfirmationDialogService } from '@globalshared/hw-confirmation-dialog/src/lib/hw-confirmation-dialog.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { RequestResult } from '@app/core/dto/RequestResult';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogAction } from '@app/core/enums/OpenDialogAction';
import { HwConfirmationDialogData } from '@globalshared/hw-confirmation-dialog/src/lib/hw-confirmation-dialog.component';
import { MaintenanceTaskEditorDialogComponent} from '@kip/dialogs/maintenance-task-editor-dialog/maintenance-task-editor-dialog.component';
import { MaintenanceTask } from '@app/kip/dto/MaintenanceTask';
import { TopBarManagerService } from '@app/core/services/topbar-manager.service';
import { MaintenanceTaskService } from '@app/kip/services/maintenance-task.service';
import { ApplicationPage } from '@app/core/enums/application-page';
import { StyleHelperService } from '@app/kip/services/style-helper.service';


@Component({
  selector: 'maintenance-task-editor',
  templateUrl: './maintenance-task-editor.component.html',
  styleUrls: ['./maintenance-task-editor.component.scss']
})
export class MaintenanceTaskEditorComponent implements OnInit,OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;
  filterForm: FormGroup;
  loaded: boolean;
  editorList: MaintenanceTask[]=[];
  allMaintenanceTasks: MaintenanceTask[]=[];
  filterCaptions: string[] = [];
  maintenanceTasks: MaintenanceTask[]=[];
  dataSource: MatTableDataSource<MaintenanceTask>;

  tableColumns = ['TaskCode','TaskName','TimeLimit','Active','Action']

  loadAllMaintenanceTasks$ : Subscription;
  hotelUnitChanged$: Subscription;
  addMaintenanceTask$: Subscription;
  deleteMaintenanceTask$: Subscription;
  updateMaintenanceTask$: Subscription;

  constructor(
    private hwAlertService: HwAlertService,
    public topBarManagerService: TopBarManagerService,
    private sessionStorageService: SessionStorageService,
    private maintenanceTaskService: MaintenanceTaskService,
    private hwAlerService: HwAlertService,
    private confirmService: HwConfirmationDialogService,
    private maintenanceTaskDialog: MatDialog,
    private translate: TranslateService,
    private fb: FormBuilder,
    public styleHelper: StyleHelperService

  ) {
    this.filterForm = fb.group({
      'fActive': new FormControl(true),
        'fTaskCode': new FormControl('', [Validators.maxLength(10)]),
        'fTaskName': new FormControl('', [Validators.maxLength(40)])
      })

   }

   //#region =============== Angular Lifecyle events ============================================================================
   ngOnInit() {
    this.topBarManagerService.setFormId(ApplicationPage.maintenance_task_editor);
    this.topBarManagerService.hotelUnitChanged.subscribe(event => {
      this.loadAll();
    });
    this.loadAll();
    
  }
  ngOnDestroy(): void {
    this.loadAllMaintenanceTasks$?.unsubscribe();
    this.hotelUnitChanged$?.unsubscribe();
    this.addMaintenanceTask$?.unsubscribe();
    this.deleteMaintenanceTask$?.unsubscribe();
    this.updateMaintenanceTask$?.unsubscribe();
    
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  sortData(sortState: Sort) {
    switch (sortState.direction) {
      case 'asc':
        this.sort.direction = 'asc';
        break;
      case 'desc':
        this.sort.direction = 'desc';
        break;
      default:
        this.sort.direction = 'asc';
    }
    this.dataSource.sort = this.sort;
  }
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  applyFilter() {
    var tmpArr: MaintenanceTask[] = [];
    var mustInclude: boolean;
    this.allMaintenanceTasks.forEach(item => {
      mustInclude = true;
      this.filterCaptions = [];
      if (this.filterForm.controls["fActive"].value && mustInclude) {
        if (!item.Active) {
          mustInclude = false;
        }
        else {
          this.filterCaptions.push(this.translate.instant("common.active"))
        }
      }
      if(!item.TaskCode.toLowerCase().startsWith(this.filterForm.controls["fTaskCode"].value.toString().toLowerCase()) && 
        this.filterForm.controls["fTaskCode"].value !== "" && mustInclude) {
        mustInclude = false;
      }
      if(!item.TaskName.toLowerCase().startsWith(this.filterForm.controls["fTaskName"].value.toString().toLowerCase())  && 
        this.filterForm.controls["fTaskName"].value !== "" && mustInclude) {
        mustInclude = false;
      }
       
      if (mustInclude) {
        tmpArr.push(item);
      }
       // update filter line
      if(this.filterForm.controls["fTaskCode"].value !=="")  {
        this.filterCaptions.push(this.translate.instant("common.code") + ": " + this.filterForm.controls["fTaskCode"].value);
      } 
      if(this.filterForm.controls["fTaskName"].value !=="")  {
        this.filterCaptions.push(this.translate.instant("common.appellation") + ": " + this.filterForm.controls["fTaskName"].value);
      } 

    })
    this.editorList = JSON.parse(JSON.stringify(tmpArr)) as MaintenanceTask[];
    this.dataSource = new MatTableDataSource(this.editorList)
    this.dataSource.sort = this.sort;

  }
  openDialog( action : string, data?:MaintenanceTask) {
    let maintenanceTaskItem: MaintenanceTask;
    if( action == OpenDialogAction.ADD) {
      maintenanceTaskItem = new MaintenanceTask();
      maintenanceTaskItem.Active = true;
      maintenanceTaskItem.HotelId = this.sessionStorageService.getSelectedHotelId();
      maintenanceTaskItem.Subscriber = this.sessionStorageService.getSelectedUnit();
      maintenanceTaskItem.TaskId = 0;
    } else {
      maintenanceTaskItem = data;
    }

    const maintenanceTaskDialogDef = this.maintenanceTaskDialog.open(MaintenanceTaskEditorDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      width: "80vw",
      panelClass: "cleaning-type-editor-dialog",
      data: maintenanceTaskItem
    });

    maintenanceTaskDialogDef.afterClosed().subscribe(data => {
      if(data) {
         const processableItem = data as MaintenanceTask;
         if(processableItem.TaskId == 0) {
          this.addMaintenanceTask$ = this.maintenanceTaskService.addMaintenanceTask(data).subscribe(result=> {
            this.showAddOrEditMessage(result as RequestResult);
            this.loadAll();
          })
         } else {
          this.updateMaintenanceTask$ = this.maintenanceTaskService.updateMaintenanceTask(data).subscribe(result => {
            this.showAddOrEditMessage(result as RequestResult);
            this.loadAll();
          })
         }
      }
    }) 
  }
  deleteRow(item: MaintenanceTask) {

    const options: HwConfirmationDialogData = {
      cancelButtonCaption: this.translate.instant("common.cancel"),
      message: this.translate.instant("common.delete_selected_rows"),
      title: this.translate.instant("common.message"),
      okButtonCaption: this.translate.instant("common.ok")
    }
    this.confirmService.open(options);
    this.confirmService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteMaintenanceTask$ = this.maintenanceTaskService.deleteMaintenanceTask(item.TaskId.toString()).subscribe(result => {
          const res = result as RequestResult;
          if (res.Code == 0) {
            this.loadAll();
          } else {
            this.hwAlertService.error(this.translate.instant("common.error_while_deleting") ,new  Alert({ autoClose:false, fade:true, position: ToastPosition.TopRight}));
          } 
         })
      }
    })
  }
  //#endr
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  loadAll() {
    this.loadAllMaintenanceTasks$ = this.maintenanceTaskService.loadAll(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId()).subscribe( result => {
      const res = result as RequestResult;
      this.editorList = res.Data as Array<MaintenanceTask>;
      this.allMaintenanceTasks = res.Data as Array<MaintenanceTask>;
      this.dataSource = new MatTableDataSource(this.editorList);
      this.dataSource.sort = this.sort;
      this.loaded = true;   
      this.applyFilter();
    })
  }

  
  showAddOrEditMessage(result: RequestResult) {
    switch(result.Code) {
      case 0:
        this.hwAlerService.info(this.translate.instant("common.saved_successfully"), new Alert({ autoClose: true, fade: true, position: ToastPosition.TopRight }));
        break;
      case -1: 
        this.hwAlerService.error(this.translate.instant("common.error_while_performing_operation"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));

        break;
      case -4:
        this.hwAlerService.error(this.translate.instant("common.task_code_already_exists"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));

        break;

    }
    if (result.Code == 0) {
      this.hwAlerService.info(this.translate.instant("common.saved_successfully"), new Alert({ autoClose: true, fade: true, position: ToastPosition.TopRight }));
    } else {
      this.hwAlerService.error(this.translate.instant("common.error_while_performing_operation"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));
    }
  }

  showDeleteMessage(result: RequestResult) {
    if (result.Code == 0) {
      this.hwAlerService.info(this.translate.instant("common.successfully_deleted"), new Alert({ autoClose: true, fade: true, position: ToastPosition.TopRight }));
    } else {
      this.hwAlerService.error(this.translate.instant("common.error_while_performing_operation"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));
    }

  }
  //#endregion =================================================================================================================


}
